/**
 * @fileoverview GET handler for the "/engagement/content_blocks/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementContentBlocksId } from "./constants";
import type { GetEngagementContentBlocksIdResult } from "./types";

export const getEngagementContentBlocksId = reactQueryFetcherAdapter(
  engagementContentBlocksId,
  (signal: AbortSignal, id: string): Promise<GetEngagementContentBlocksIdResult> => {
    return fetch(
      `/engagement/content_blocks/${id}`,
      "GET",
      {},
      { signal },
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
